const catalogStates = new WeakMap();
const searchHandlers = new Set([
    'onSearchProduct',
    'onSearchProducts',
    'onSearchSelectChildrenProducts',
]);
const filterHandlers = new Set([
    'onFilterCategory',
    'onFilterByCategory',
    'onFilterSelectChildrenCategory',
]);
const catalogHandlers = new Set([
    ...searchHandlers,
    ...filterHandlers,
    'onAjax',
    'onLoadProductsListForSelectAsChildren',
    'onAddChild',
]);

function getState(scope) {
    if (!catalogStates.has(scope)) {
        catalogStates.set(scope, { revision: 0, timer: null });
    }

    return catalogStates.get(scope);
}

document.addEventListener('input', function (event) {
    const input = event.target.closest('[data-catalog-search-live]');
    const scope = input?.closest('[data-catalog-search]');
    if (!scope) return;

    const state = getState(scope);
    state.revision++;
    clearTimeout(state.timer);
    state.timer = setTimeout(function () {
        if (input.isConnected) {
            oc.request(input, input.dataset.request);
        }
    }, 300);
});

document.addEventListener('keydown', function (event) {
    const input = event.target.closest('[data-catalog-search-live]');
    if (!input || event.key !== 'Enter') return;

    event.preventDefault();
    clearTimeout(getState(input.closest('[data-catalog-search]')).timer);
    oc.request(input, input.dataset.request);
});

document.addEventListener('ajax:setup', function (event) {
    const context = event.detail.context;
    const scope = context.el.closest?.('[data-catalog-search]');
    const handler = context.handler.split('::').pop();
    if (!scope || !catalogHandlers.has(handler)) return;

    const state = getState(scope);
    const input = scope.querySelector('[data-catalog-search-input]');
    const queryKey = scope.dataset.catalogSearch;
    const isSearch = searchHandlers.has(handler);
    let resetPage = isSearch || filterHandlers.has(handler);

    // Apply pending live text when another catalog control is used.
    if (input && (isSearch || input.hasAttribute('data-catalog-search-live'))) {
        const term = input.value.trim();
        const previousTerm = new URLSearchParams(window.location.search).get(queryKey) || '';
        resetPage = resetPage || term !== previousTerm;
        context.options.query = { ...context.options.query, [queryKey]: term || null };
        if (isSearch) {
            context.options.data = { ...context.options.data, [input.name]: term };
        }
    }

    if (resetPage) {
        context.options.query = { ...context.options.query, page: null };
    }

    clearTimeout(state.timer);
    const revision = ++state.revision;
    const beforeUpdate = context.options.beforeUpdate;
    context.options.beforeUpdate = function (data, ...args) {
        if (!scope.isConnected || state.revision !== revision) {
            // Keep framework errors, redirects and completion callbacks, but discard stale HTML.
            for (const key of Object.keys(data)) {
                if (!key.startsWith('X_OCTOBER_')) {
                    delete data[key];
                }
            }
        }

        return beforeUpdate?.call(this, data, ...args);
    };
});
